<div style="padding:30px">  
    <select class="form-control"
    *ngIf="vendor_list.length>1"
    style="width: 160px;display: inline-block;"
    [(ngModel)]="vid"
    (change)="pageobj.page=0;init_list()"
    >
    <option *ngFor="let item of vendor_list" [ngValue]="item.id">{{item.name}}</option>
    </select>
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>
    <button class="btn btn-primary" (click)="subnow='1';edit_data.id=-1"  data-toggle="modal" data-target=".bd-example-modal-xl">新增級距資料</button>
    <div *ngIf="now=='1'||now=='2'" class="tips">所有設定將於下一期生效。若無調整設定將自動延續至下一期</div>
    <div *ngIf="now=='1'||now=='2'" class="tips">若無設定任何門檻將以千鑽為單位直接進行兌換</div>
    <div *ngIf="now=='3'||now=='4'" class="tips">所有設定將於下月1日結算本月薪資時生效</div>
    <table style="margin-top: 10px;" class="table table-responsive-sm" *ngIf="now!='3' && data.length>0">
        <thead>
        <tr class="table-primary" style="font-size:18px;">
            <th style="width:8%;overflow: auto;">級距</th>
            <th  *ngIf="now=='1'" style="width:5%">匯率</th>
            <th  *ngIf="now=='2'" style="width:5%">獎金</th>
            <th  *ngIf="now=='4'" style="width:5%">匯率</th>
            <th style="width:5%">狀態</th>
            <th style="width:5%">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of data; let i = index" class="{{(item.lock==1)?'table-secondary':''}}">
            <td>{{item.diamond_start|number}}~{{item.diamond_end|number}}</td>
            <td  *ngIf="now=='1'">{{item.percent}}%</td>
            <td  *ngIf="now=='2'">
                {{item.points}}元
            </td>
            <td  *ngIf="now=='4'">0.0{{item.percent}}</td>
            <td>
                <span  *ngIf="item.lock!=1">{{item.status==1?'啟用':'不啟用'}}</span>
                <span  *ngIf="item.lock==1">過期</span>
            </td>
            <td>
                <span *ngIf="item.lock==1">
                   {{item.dead_line_date}}已生效
                </span>
                <span *ngIf="item.lock!=1">
                    <a href="javascript:void(0)" title="點我設定"  (click)="edit_data=item;subnow='2'" data-toggle="modal" data-target=".bd-example-modal-xl">
                        <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                    </a>
                </span>

            </td>
        </tr>
        </tbody>
    </table>
    <table style="margin-top: 10px;" class="table table-responsive-sm" *ngIf="now=='3' && data.length>0">
        <thead>
        <tr class="table-primary" style="font-size:18px;">
            <th style="width:8%;overflow: auto;">提領金額達</th>
            <th style="width:5%">發放鑽石</th>
            <th style="width:5%">週期</th>
            <th style="width:5%">等級</th>
            <th style="width:5%">狀態</th>
            <th style="width:5%">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of data; let i = index" class="{{(item.lock==1)?'table-secondary':''}}">
            <td>{{item.diamond_end|number}}</td>
            <td>
                {{item.points}}鑽
            </td>
            <td>
                <span *ngIf="item.lock==1">
                    限本月~{{item.dead_line_date}}
                </span>
                <span *ngIf="item.lock==0">
                    每個月
                 </span>
            </td>
            <td>
                {{item.lv}}
            </td>
            <td>
                <span>{{item.status==1?'啟用':'不啟用'}}</span>
            </td>
            <td>
                <a href="javascript:void(0)" title="點我設定"  (click)="item.points_type=item.lock;edit_data=item;subnow='2'" data-toggle="modal" data-target=".bd-example-modal-xl">
                    <i style="margin-right:10px" class="fas fa-file-signature" ></i>
                </a>
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="data.length==0">無資料</div>
    <app-pagnation (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>
   
    <div 
    *ngIf="edit_data"
    class="modal fade bd-example-modal-xl" tabindex="-1"
     role="dialog"  data-keyboard="false" data-backdrop="static" 
     aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
      style="max-height: 650px;overflow:auto;"
     >
      <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" >{{now=='1'?'薪資':'獎金'}}設定</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div *ngIf="now!='3'" style="padding: 10px;">
                <div class="user_edit_block">
                    <label class="col-sm-2 col-form-label">級距範圍</label>
                    {{edit_data.diamond_start}} ~
                    <input type="number" [(ngModel)]="edit_data.diamond_end" placeholder="門檻鑽石數" class="form-control fix_input" >鑽
                    <div class="tips col-sm-2 col-form-label" *ngIf="now=='1'">最後一筆的最大值將視為∞ ex:（級距為1~200,200~500 那麼計算時將會把200~500當成200~∞）</div>
                </div>
               
                <div class="user_edit_block"  *ngIf="now=='2'">
                    <label class="col-sm-2 col-form-label">實領金額</label>
                    <input type="number" [(ngModel)]="edit_data.points" placeholder="3,000元" class="form-control fix_input" >元
                    <div class="tips col-sm-2 col-form-label">ex:（達到鑽石50,000直接領3,000元）</div>
                </div>
                <div class="user_edit_block" *ngIf="now=='1'">
                    <label class="col-sm-2 col-form-label">抽成匯率</label>
                    <input type="range"
                     [(ngModel)]="edit_data.percent"
                     step="2.5" max="100" min="10" class="form-control fix_input" style="padding: 0;">{{edit_data.percent}}%
                    <div class="tips col-sm-2 col-form-label"> ex:（達到鑽石50,000 且比率為50% 則將獲得 50,000 * 0.12 * 0.5 = 3,000元）</div>
                </div>
                <div class="user_edit_block" *ngIf="now=='4'">
                    <label class="col-sm-2 col-form-label">匯率</label>
                    0.0
                    <!--<input type="number"
                     [(ngModel)]="edit_data.percent"
                      class="form-control fix_input" style="padding: 0;">-->
                    <select class="form-control"
                    style="width: 160px;display: inline-block;"
                    [(ngModel)]="edit_data.percent"
                    >
                        <option *ngFor="let id of generateIdArray(60, 80)" [ngValue]="id">{{ id }}</option>
                    </select>
                    
                </div>
                <div *ngIf="now=='1'" class="tips col-sm-2 col-form-label" style="color:red">根據會員獎勵設定,抽成匯率與實領金額將二擇一進行計算</div>
                <div class="user_edit_block" *ngIf="subnow=='2'">
                    <label class="col-sm-2 col-form-label">是否啟用</label>
                    <button (click)="edit_data.status='1'"  [ngClass]="edit_data.status=='1'?'btn-success':'btn-secondary'"  class="btn  m5">是</button>
                    <button (click)="edit_data.status='0'"  [ngClass]="edit_data.status=='0'?'btn-success':'btn-secondary'"  class="btn  m5">否</button>
                    <div class="tips col-sm-2 col-form-label">若將啟用改為"否"將刪除該設定</div>
                </div>
            </div>
            <div *ngIf="now=='3'" style="padding: 10px;">
                <div class="user_edit_block">
                    <label class="col-sm-2 col-form-label">提領獎金達</label>
                    <input type="number" [(ngModel)]="edit_data.diamond_end" placeholder="目標檻鑽石數" class="form-control fix_input" >鑽
                </div>
                <div class="user_edit_block">
                    <label class="col-sm-2 col-form-label">發放鑽石數</label>
                    <input type="number" [(ngModel)]="edit_data.points" placeholder="發放鑽石數" class="form-control fix_input" >鑽
                </div>
                <div class="user_edit_block">
                    <label class="col-sm-2 col-form-label">等級</label>
                    <input type="number" [(ngModel)]="edit_data.lv" placeholder="等級" class="form-control fix_input" >
                </div>
                <div class="user_edit_block">
                    <label class="col-sm-2 col-form-label">使用週期</label>
                    <button (click)="edit_data.points_type='1'"  [ngClass]="edit_data.points_type=='1'?'btn-success':'btn-secondary'"  class="btn  m5">限本月</button>
                    <button (click)="edit_data.points_type='0'"  [ngClass]="edit_data.points_type=='0'?'btn-success':'btn-secondary'"  class="btn  m5">每個月</button>
                </div>
                <div class="user_edit_block" *ngIf="subnow=='2'">
                    <label class="col-sm-2 col-form-label">是否啟用</label>
                    <button (click)="edit_data.status='1'"  [ngClass]="edit_data.status=='1'?'btn-success':'btn-secondary'"  class="btn  m5">是</button>
                    <button (click)="edit_data.status='0'"  [ngClass]="edit_data.status=='0'?'btn-success':'btn-secondary'"  class="btn  m5">否</button>
                    <div class="tips col-sm-2 col-form-label">若將啟用改為"否"將刪除該設定</div>
                </div>
            </div>
          
            <!-- Modal footer -->
            <div class="modal-footer" >
                <button type="button"   (click)="save()"    class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button"   (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
          </div>
      </div>
    </div>
</div>